function coalesce(s) {
    if (s === null || s === undefined || s === "null")
        return "";
    else
        return s;
}

// Restituisce true se la stringa passata è vuota o non definita
function isEmpty(s) {
    if (s === null || s === undefined)
        return true;
    else {
        s = s + "";
        return s.trim() === "";
    }
}

// Recupera dalle traduzioni del campo dell'elemento passato la traduzione della lingua fornita
function getTranslation(element, field, lang) {
    let result = null;
    if (element == null)
        return result;
    for (let trad in element["traduzioni"]) {
        if (element["traduzioni"][trad]["lingua"].startsWith(lang)) {
            result = element["traduzioni"][trad][field];
        }
    }
    if (isEmpty(result)) {
        for (let trad in element["traduzioni"]) {
            if (element["traduzioni"][trad]["lingua"].startsWith("it")) {
                result = element["traduzioni"][trad][field];
            }
        }
    }
    return result;
}

// Recupera dalle traduzioni del sottocampo del record con nome passato la traduzione della lingua fornita
function getTranslationSubField(element, field, fieldValue, subfield, lang) {
    let result = null;
    if (element == null)
        return result;
    for (let i in element) {
        if (element[i][field] == fieldValue) {
            for (let trad in element[i]["traduzioni"]) {
                if (element[i]["traduzioni"][trad]["lingua"].startsWith(lang)) {
                    if (element[i]["traduzioni"][trad][subfield] != null)
                        result = element[i]["traduzioni"][trad][subfield];
                }
            }
            if (isEmpty(result)) {
                for (let trad in element[i]["traduzioni"]) {
                    if (element[i]["traduzioni"][trad]["lingua"].startsWith("it")) {
                        if (element[i]["traduzioni"][trad][subfield] != null)
                            result = element[i]["traduzioni"][trad][subfield];
                    }
                }
            }
        }
    }
    return result;
}

// Recupera dalle traduzioni presenti nel campo descrizione dei file il titolo
function getFileTranslation(description, lang) {
    let result = null;
    if (description == null)
        return result;

    // Es. formato: en{Title}
    let index1 = description.indexOf(lang + "{");
    if (index1 === -1) { // Cerca l'italiano
        lang = "it";
        index1 = description.indexOf(lang + "{");
    }
    if (index1 > -1) {
        let index2 = description.indexOf("}", index1);
        result = description.substring(index1 + (lang + "{").length, index2);
    }
    return result;
}

export default {
    coalesce,
    isEmpty,
    getTranslation,
    getTranslationSubField,
    getFileTranslation
}